// extracted by mini-css-extract-plugin
module.exports = {"div":"Styles_div__2zv9t","foodChar":"Styles_foodChar__19Ptk"};